module.exports = __webpack_public_path__ + "media/images/setup_launch_illustration-1e63028c1b301c0c2532907a7b7e2d7f.svg";